import { ILanguageNode } from '@packlink/translation-provider';
import { SET_AVAILABLE_LANGUAGES, SET_LOCALE } from './action-types';
import i18n from 'i18next';
import moment from 'moment';

export interface ISetAvailableLanguages {
    type: 'SET_AVAILABLE_LANGUAGES';
    payload: ILanguageNode[];
}

export interface ISetLocaleAction {
    type: 'SET_LOCALE';
    payload: string;
}

export type LanguageAction = ISetAvailableLanguages | ISetLocaleAction;

export const setAvailableLanguages = (data: ILanguageNode[]): ISetAvailableLanguages => ({
    type: SET_AVAILABLE_LANGUAGES,
    payload: data,
});

export const setLocale = (locale: string): ISetLocaleAction => {
    moment.locale(locale);
    if (i18n.language && i18n.language !== locale) {
        i18n.changeLanguage(locale);
    }
    return { type: SET_LOCALE, payload: locale };
};
